/**
 * Regtank onboarding modal titles
 */
export const ONBOARDING_MODAL_TITLES = {
  EXISTING_USER: "Identity Verification",
  NEW_USER: "e-KYC",
} as const;

/**
 * Regtank onboarding modal first line text
 */
export const MODAL_FIRST_LINE = {
  EXISTING_USER:
    "We have enhanced our identity verification process to better protect your interests.",
  NEW_USER:
    "Please ensure you have your national identification document ready, then click the 'Start Verification' button to begin the e-KYC process.",
} as const;

/**
 * Regtank onboarding modal second line text
 */
export const MODAL_SECOND_LINE = {
  EXISTING_USER:
    "To access your account, please complete the new verification process.",
  NEW_USER:
    "By proceeding, you confirm that the details provided are accurate and consent to FundedHere collecting and sharing your information for verification and onboarding purposes, including the opening of any required collection accounts.",
} as const;
